$('.mask-date').mask('00/00/0000');
$('.mask-cep').mask('00000-000');
$('.mask-document').mask('000.000.000-00', {reverse: true});
$('.mask-integer').mask('Z',{translation:  {'Z': {pattern: /^[0-9]+$/, recursive: true}}});
$('.mask-height').mask('Zcm',{reverse: true, translation:  {'Z': {pattern: /^[0-9]+$/, recursive: true}}});
$('.mask-weigth').mask('Zkg',{reverse: true, translation:  {'Z': {pattern: /^[0-9]+$/, recursive: true}}});

var SPMaskBehavior = function (val) {
  return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
};
var spOptions = {
  onKeyPress: function(val, e, field, options) {
    field.mask(SPMaskBehavior.apply({}, arguments), options);
  },
};
$('.mask-phone').mask(SPMaskBehavior, spOptions);



// WEBPACK FOOTER //
// ./scripts/components/masks.js